import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule, CommonTranslationModule, DictionaryModule } from '@sdbn/common';
import { TransportRegistrationInstructionsComponent } from './component/transport-registration-instructions.component';



@NgModule({
  declarations: [
    TransportRegistrationInstructionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatCheckboxModule,
    MatInputModule
  ]
})
export class TransportRegistrationInstructionsModule { }
